import React, { useState } from 'react';
import { MapPin, ChevronLeft, Store, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

// 1. DATA DEFINITION (Fixed: Now defined before usage)
const branchData = {
  "Afam Bakery": [
    { 
      name: "Platinum Corner Trading Est", 
      arName: "مؤسسة ركن البلاتين التجارية", 
      address: "Fatimah Al Zahra, Jarir St. Al Malaz, Riyadh", 
      arAddress: "فاطمة الزهراء، شارع جرير، الملز، الرياض",
      Openinghour: "Opening Hour: 05:00 AM To 02:00 AM", 
      arOpeninghour: "الساعة 05:00 صباحًا  إلى الساعة 02:00 صباحًا", 
      map: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5821.517693810262!2d46.73951526805902!3d24.680475092637764!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f041ef3e0d425%3A0x7b5f226d14c69196!2z2YXYrtin2KjYsiDZiNit2YTZiNmK2KfYqiDYudio2K8g2KfZhNmE2Ycg2YHZh9ivINi52YrYryDYp9mE2YXZhtmK2YfYsdmK!5e0!3m2!1sen!2ssa!4v1784568079257!5m2!1sen!2ssa" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>` 
    },
  ],
  "Super Market": [
    { 
      name: "Platinum Super Market", 
      arName: "سوبر ماركت الركن البلاتيني", 
      address: "Fatimah Al Zahra, Jarir St. Al Malaz, Riyadh", 
      arAddress: "فاطمة الزهراء، شارع جرير، الملز، الرياض",
      Openinghour: "Opening Hour: 24 Hours", 
      arOpeninghour: "24 ساعة", 
      map: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d453.1785855527963!2d46.745026019278086!3d24.67778617761476!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f050054e9343b%3A0x1930f30c4d638d17!2sPlatinum%20corner%20supermarket!5e0!3m2!1sen!2ssa!4v1784568762493!5m2!1sen!2ssa" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>` 
    }
  ],
  "Afam Restaurant": [
    { 
      name: "Bismillah Restaurant", 
      arName: "مطعم بسم الله", 
      address: "Fatimah Al Zahra, Jarir St. Al Malaz, Riyadh", 
      arAddress: "فاطمة الزهراء، شارع جرير، الملز، الرياض", 
      map: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d226.59023511086266!2d46.74519199369675!3d24.677267584242117!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f0500459239df%3A0x1678dbaf6376862a!2z2YTZhNmI2KzYqNin2Kog2KfZhNiz2LHZiti5!5e0!3m2!1sen!2ssa!4v1784573734591!5m2!1sen!2ssa" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>` 
    },
    { 
      name: "Platinum Corner Restaurant", 
      arName: "مطعم الركن البلاتيني", 
      address: "Al Malaz, Riyadh", 
      arAddress: "الملز، الرياض", 
      map: `<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3625.547188922018!2d46.709432875364854!3d24.673709878051664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDQwJzI1LjQiTiA0NsKwNDInNDMuMiJF!5e0!3m2!1sen!2ssa!4v1784568969100!5m2!1sen!2ssa" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>`
    },
  ],
  "Afam Grocery": [
    { name: "Branch 01(Fahad Bakala)", arName: "فرع أفام 1", address: "Fatimah Al Zahra, Jarir St. Al Malaz, Riyadh", arAddress: "فاطمة الزهراء، شارع جرير، الملز، الرياض", map: `<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3625.4763523907973!2d46.743473475365086!3d24.676146578050062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDQwJzM0LjEiTiA0NsKwNDQnNDUuOCJF!5e0!3m2!1sen!2ssa!4v1784573769256!5m2!1sen!2ssa" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>` },
    { name: "Branch 02", arName: "فرع أفام 2", address: "Fatimah Al Zahra, Jarir St. Al Malaz, Riyadh", arAddress: "فاطمة الزهراء، شارع جرير، الملز، الرياض", map: "#" },
    { name: "Branch 03", arName: "فرع أفام 3", address: "ishara Director, Riyadh", arAddress: "إشارة، مدير، الرياض", map: `<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3626.5076901821917!2d46.72691537536374!3d24.64064737807343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDM4JzI2LjMiTiA0NsKwNDMnNDYuMiJF!5e0!3m2!1sen!2ssa!4v1784573647144!5m2!1sen!2ssa" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>` },
  ],
  "Meat & Fish Shop": [
    { name: "Afam Meat & Fish Shop", arName: "ملحمة وأسماك أقام", address: "Fatimah Al Zahra, Jarir St. Al Malaz, Riyadh", arAddress: "فاطمة الزهراء، شارع جرير، الملز، الرياض", map: "#" }
  ],
  "AFAM Factory": [
    { 
      name: "Platinum Corner Trading Est", 
      arName: "مؤسسة ركن البلاتين التجارية", 
      address: "Al Misfat, Riyadh.", 
      arAddress: "المسفاة، الرياض", 
      map: `<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3629.980429295785!2d46.89375307536!3d24.520759578152596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDMxJzE0LjciTiA0NsKwNTMnNDYuOCJF!5e0!3m2!1sen!2ssa!4v1784573372877!5m2!1sen!2ssa" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>` 
    }
  ]
};

const Branches = () => {
  const { isArabic } = useLanguage();
  const [selectedService, setSelectedService] = useState(null);

  const services = [
    { title: "Afam Bakery", arTitle: "مخبز أقام", image: "https://images.unsplash.com/photo-1509440159596-0249088772ff?q=80&w=600" },
    { title: "Super Market", arTitle: "بلاتينيوم سوبر ماركت", image: "https://images.unsplash.com/photo-1542838132-92c53300491e?q=80&w=600" },
    { title: "Afam Restaurant", arTitle: "مطعم أقام", image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=600" },
    { title: "Afam Grocery", arTitle: "تموينات أقام", image: "https://images.unsplash.com/photo-1534723452862-4c874018d66d?q=80&w=600" },
    { title: "Meat & Fish Shop", arTitle: "ملحمة وأسماك أقام", image: "/fishmeat.jpg" },
    { title: "AFAM Factory", arTitle: "مصنع أفام", image: "https://images.unsplash.com/photo-1586528116311-ad8ed7c83a00?q=80&w=600" },
  ];

  const getBranches = (title) => branchData[title] || [];

  return (
    <section id="branches" className="py-24 bg-slate-50 min-h-[700px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header - Hides when a branch is selected for a cleaner look */}
        <div className={`mb-12 transition-all duration-500 ${selectedService ? 'opacity-0 h-0 overflow-hidden' : 'opacity-100'}`}>
          <h2 className={`text-4xl font-bold text-corp-blue mb-4 ${isArabic ? 'text-right' : 'text-left'}`}>
            {isArabic ? 'فروعنا' : 'Our Branches'}
          </h2>
          <div className={`w-20 h-1.5 bg-saudi-green ${isArabic ? 'ml-auto' : ''} rounded-full`}></div>
        </div>

        <div className="relative">
          {!selectedService ? (
            /* VIEW 1: Grid of Services */
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <div 
                  key={index}
                  onClick={() => setSelectedService(service)}
                  className="relative group h-80 rounded-3xl overflow-hidden cursor-pointer shadow-md hover:shadow-2xl transition-all hover:-translate-y-2"
                >
                  <img src={service.image} alt={service.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-corp-blue via-transparent to-transparent"></div>
                  <div className={`absolute bottom-6 w-full px-6 ${isArabic ? 'text-right' : 'text-left'}`}>
                    <h3 className="text-2xl font-bold text-white">{isArabic ? service.arTitle : service.title}</h3>
                    <p className="text-saudi-green font-bold flex items-center gap-2 mt-2 opacity-0 group-hover:opacity-100 transition-all transform translate-y-2 group-hover:translate-y-0">
                      {isArabic ? 'عرض الفروع' : 'View Branches'} <ArrowRight size={18} className={isArabic ? 'rotate-180' : ''} />
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            /* VIEW 2: Drill-down Branch List */
            <div className={`flex flex-col lg:flex-row gap-8 ${isArabic ? 'lg:flex-row-reverse' : ''}`}>
              
              {/* Left Column: Fixed Service Card */}
              <div className="lg:w-1/3">
                <button 
                  onClick={() => setSelectedService(null)}
                  className="mb-6 flex items-center gap-2 text-corp-blue font-bold hover:text-saudi-green transition-colors"
                >
                  <ChevronLeft size={20} className={isArabic ? 'rotate-180' : ''} />
                  {isArabic ? 'العودة' : 'Back to Categories'}
                </button>
                
                <div className="relative h-[450px] rounded-3xl overflow-hidden shadow-2xl">
                  <img src={selectedService.image} alt="" className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-corp-blue/70 backdrop-blur-sm"></div>
                  <div className="absolute inset-0 flex flex-col justify-center items-center text-white p-8 text-center">
                    <Store size={64} className="mb-4 text-saudi-green" />
                    <h3 className="text-4xl font-bold mb-4">{isArabic ? selectedService.arTitle : selectedService.title}</h3>
                    <div className="w-12 h-1 bg-saudi-green rounded-full"></div>
                  </div>
                </div>
              </div>

              {/* Right Column: Dynamic Branch Cards */}
              <div className="lg:w-2/3">
                <h4 className={`text-2xl font-bold text-corp-blue mb-8 ${isArabic ? 'text-right' : 'text-left'}`}>
                  {isArabic ? 'المواقع المتاحة' : 'Available Locations'}
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {getBranches(selectedService.title).map((branch, idx) => (
                    <div key={idx} className={`p-8 bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-all ${isArabic ? 'text-right' : 'text-left'}`}>
                      <div className={`w-12 h-12 bg-saudi-green/10 rounded-full flex items-center justify-center text-saudi-green mb-4 ${isArabic ? 'ml-auto' : ''}`}>
                        <MapPin size={24} />
                      </div>
                      <h5 className="font-bold text-corp-blue text-xl mb-2">
                        {isArabic ? branch.arName : branch.name}
                      </h5>
                      <p className="text-gray-500 mb-6">
                        {isArabic ? branch.arAddress : branch.address}
                      </p>
                      
                      {/* Added safety check for Openinghour so it doesn't render an empty space for Factory */}
                      {branch.Openinghour && (
                        <p className="text-green-500 mb-6">
                          {isArabic ? branch.arOpeninghour : branch.Openinghour}
                        </p>
                      )}

                      {branch.map !== "#" ? (
                      /* This renders the iframe and uses Tailwind to force the width to fit the card */
                      <div 
                        className="w-full mt-4 rounded-xl overflow-hidden [&>iframe]:w-full [&>iframe]:h-48"
                        dangerouslySetInnerHTML={{ __html: branch.map }}
                        />
                    ) : (
                      /* Fallback button if no map is provided */
                      <button className="w-full py-3 rounded-xl border border-slate-200 text-corp-blue font-bold text-sm hover:bg-corp-blue hover:text-white transition-all cursor-not-allowed opacity-50">
                        {isArabic ? 'الخريطة غير متوفرة' : 'Map Unavailable'}
                      </button>
                    )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Branches;
